"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formFieldFactory = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const formik_1 = require("formik");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const form_field_wraper_1 = require("./wrapper/form-field-wraper");
const form_context_1 = require("../form-context");
const form_field_context_1 = require("./form-field-context");
const memo_compare_hook_1 = require("../../../utils/memo-compare-hook");
function formFieldFactory(Component, Wrapper = form_field_wraper_1.FormFieldWrapper) {
    const MemoizedComponent = react_1.default.memo(Component);
    return function FormField({ name: providedName, label, helpLabel, notifyChange = lodash_1.noop, required = false, disabled = false, before, after, ...props }) {
        const formFieldContext = react_1.useContext(form_field_context_1.FormFieldContext);
        const { errorOptions, labelOptions, layoutOptions } = {
            labelOptions: react_1.useMemo(() => ({}), []),
            layoutOptions: react_1.useMemo(() => ({}), []),
            errorOptions: react_1.useMemo(() => ({}), []),
            ...props,
        };
        const name = formFieldContext.prefix !== undefined
            ? `${formFieldContext.prefix}.${providedName}`
            : providedName;
        const [field, , helpers] = formik_1.useField(name);
        const handleChange = event_callback_hook_1.useEventCallback((value) => {
            helpers.setValue(value);
            // Do the notification on next frame, so the data in form are current
            requestAnimationFrame(() => notifyChange());
        });
        const { editing, formId, errors } = react_1.useContext(form_context_1.FormContext);
        const fieldErrors = react_1.useMemo(() => errors.filter((e) => e.key === name), [
            errors,
            name,
        ]);
        const memoizedProps = memo_compare_hook_1.useMemoCompare(props, lodash_1.isEqual);
        return react_1.useMemo(() => {
            var _a, _b, _c;
            return (react_1.default.createElement(Wrapper, { label: label, helpLabel: helpLabel, required: (_a = formFieldContext.required) !== null && _a !== void 0 ? _a : required, disabled: (_b = formFieldContext.disabled) !== null && _b !== void 0 ? _b : (!editing || disabled), labelOptions: labelOptions, layoutOptions: layoutOptions, errorOptions: errorOptions, before: before, after: after, errors: fieldErrors },
                react_1.default.createElement(MemoizedComponent, Object.assign({ name: name }, memoizedProps, { form: formId, disabled: (_c = formFieldContext.disabled) !== null && _c !== void 0 ? _c : (!editing || disabled), value: field.value, onChange: handleChange }))));
        }, [
            label,
            helpLabel,
            formFieldContext,
            required,
            disabled,
            editing,
            labelOptions,
            layoutOptions,
            errorOptions,
            before,
            after,
            fieldErrors,
            name,
            formId,
            field.value,
            handleChange,
            memoizedProps,
        ]);
    };
}
exports.formFieldFactory = formFieldFactory;
//# sourceMappingURL=form-field.js.map